import React, { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { Icon, AccessibilityWrapper } from 'legacy-packages/ft-cb';

import Checkbox from '../SelectionBox';

import './index.scss';

const DropDownSelect = (props) => {
  const [isClassSelectorInputOpened, setIsClassSelectorInputOpened] =
    useState(false);
  const [selectAllClassesButtonPressed, setSelectAllClassesButtonPressed] =
    useState(false);

  const {
    handleBatchSelect,
    setSelectedItems,
    isAllItemSelected,
    items,
    selectedItems,
    dropDownSelectCloseText,
    dropDownSelectOpenText,
    resourceShareData,
    cachedAssignData,
    savedClasses,
    renderAssignedOnValue,
    showAssigned,
  } = props;

  const dropdownSelectRef = useRef(null);

  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [dropdownSelectRef]);

  const handleClick = (event) => {
    if (
      dropdownSelectRef.current &&
      !dropdownSelectRef.current.contains(event.target)
    ) {
      setIsClassSelectorInputOpened(false);
    }
  };

  const dropDownSelectText = isClassSelectorInputOpened
    ? dropDownSelectOpenText
    : dropDownSelectCloseText;
  let selectAllClassesButtonLabel =
    !isAllItemSelected() || !selectAllClassesButtonPressed
      ? 'Unselect All'
      : 'Select All';
  selectAllClassesButtonLabel =
    !selectAllClassesButtonPressed && !isAllItemSelected()
      ? 'Select All'
      : selectAllClassesButtonLabel;
  return (
    <div
      ref={dropdownSelectRef}
      className="dropdown-select"
      role="presentation"
      onKeyDown={(e) =>
        e.target.id !== 'toggleSelectAllButton' &&
        e.keyCode === 9 &&
        setSelectAllClassesButtonPressed(false)
      }
    >
      <AccessibilityWrapper>
        <button
          aria-haspopup="true"
          aria-expanded={isClassSelectorInputOpened ? 'true' : 'false'}
          className={cn('dropdown-select__icon', {
            'dropdown-select__icon--open': isClassSelectorInputOpened,
          })}
          onClick={() =>
            setIsClassSelectorInputOpened(!isClassSelectorInputOpened)
          }
        >
          <span aria-label={dropDownSelectText}>{dropDownSelectText}</span>
          <Icon name="menu_down" size="1.2rem" />
        </button>
      </AccessibilityWrapper>
      {isClassSelectorInputOpened && (
        <ul className="dropdown-select__list" role="menu">
          <li>
            <button
              onClick={() => {
                setSelectAllClassesButtonPressed(true);
                handleBatchSelect(selectedItems, items);
              }}
              tabIndex={0}
              aria-label={selectAllClassesButtonLabel}
              onKeyDown={(e) =>
                (e.keyCode === 32 || e.keyCode === 13) &&
                setSelectAllClassesButtonPressed(true)
              }
              id="toggleSelectAllButton"
              aria-pressed={selectAllClassesButtonPressed}
            >
              {isAllItemSelected() ? 'Unselect All' : 'Select All'}
            </button>
            {showAssigned && (
              <span className="dropdown-select__assigned-on dropdown-select__assigned-on__title">
                Assigned On:
              </span>
            )}
          </li>
          {items.map((item) => (
            <li key={item.id}>
              <Checkbox
                key={item.id}
                checked={selectedItems.some(
                  (selectdItemId) => selectdItemId === item.id,
                )}
                onClick={() => setSelectedItems(item.id)}
                label={item.name}
              />
              {renderAssignedOnValue(
                showAssigned,
                savedClasses,
                resourceShareData,
                cachedAssignData,
                item,
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

DropDownSelect.propTypes = {
  handleBatchSelect: PropTypes.func.isRequired,
  setSelectedItems: PropTypes.func.isRequired,
  isAllItemSelected: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  selectedItems: PropTypes.arrayOf(PropTypes.any).isRequired,
  dropDownSelectCloseText: PropTypes.string.isRequired,
  dropDownSelectOpenText: PropTypes.string.isRequired,
  renderAssignedOnValue: PropTypes.func,
};

DropDownSelect.defaultProps = {
  renderAssignedOnValue: () => {},
};

export default DropDownSelect;
